<template>
  <div></div>
</template>

<script>
import { auth, publicUrl } from 'utils'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('clientConfig', ['client_config'])
  },

  created () {
    const region = this.$user ? this.$user.region.shortname : null
    auth.logout().then(() => {
      if (this.client_config.modules.vlast_mode) {
        this.$router.push({ name: 'login' })
      } else {
        window.location.assign(publicUrl('login', region))
      }
    })
  }
}
</script>
